import { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";

export const NewRowForm = ({
  onClose = () => {},
  onCreate = console.log
}: {
  onClose?: () => void,
  onCreate?: (count: number) => void
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [form, setForm] = useState<any>({
    count: 1,
  })

  const onSubmit = async (e:any) => {
    e?.preventDefault();
    setIsLoading(true);
    onCreate(form.count);
    setIsLoading(false);
    onClose();
  }

  return (
  <div className="fixed z-10 inset-0 overflow-y-auto">
    <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div className="fixed inset-0 transition-opacity" aria-hidden="true">
        <div className="absolute inset-0 bg-black/50" />
      </div>
      <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
      <div className="z-1 relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-[0_8px_30px_rgba(0,0,0,0.12)] transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
        <div className="flex justify-between">
          <div className="text-lg">Add Rows</div>
          <button onClick={onClose} className="cursor-pointer">
            <AiOutlineClose />
          </button>
        </div>
        <div>
          <form onSubmit={onSubmit}>
            <div>
              <label className="block text-sm font-medium text-[#444] mb-2">
                How many rows would you like to create?
              </label>
              <input 
                required 
                onChange={(e) => setForm({...form, count: Number(e.target.value || 1)})} 
                className="w-full border border-[#eaeaea] my-4 rounded-md p-2" 
                type="number" 
                placeholder="Number of rows" 
                defaultValue={form.count}
                min="1"
                max="50"
              />
            </div>
            <div className="mt-4">
              {isLoading ? (<>Creating rows...</>) : 
              (<button 
                type="submit" 
                className="bg-primary hover:bg-primary/90 font-bold py-2 px-4 rounded cursor-pointer"
              >
                Create {form.count} Row{form.count > 1 ? 's' : ''}
              </button>)}
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  );
};
